import React from 'react'
import Wizard from 'components/Wizard'
import { domainName, baseUrl } from 'utils/parseDomain'
import SetupAccount from 'components/SetupAccount'
import BasicDetails from 'components/BasicDetails'
import { monthNumericMap } from 'utils/validations'
import DeviceId from 'utils/detectDevice'
import { getRecaptchaToken } from 'utils/recaptchaToken'

const formName = csDomain => {
  const arrTemp = csDomain.split('.')
  return `DR_GATSBY_${arrTemp[0].toUpperCase()}_HOMEPAGE`
}

// This change helps wrong redirections to gatsby instead of zend pages from email campaigns
const isEmailCampaign = url =>
  url.indexOf('RT_MAIL') !== -1 || url.indexOf('RT_SMS') !== -1

const arrFormReferers = () => ({
  form_referral_url: isEmailCampaign(window.location.href)
    ? window.location.href
    : baseUrl,
  form_url: baseUrl,
  form_name: formName(domainName),
  frompage: `From Gatsby Reg Layer`,
  oscode: DeviceId.isDesktop() ? '0' : '5',
})

const onSubmit = async values => {
  getRecaptchaToken().then(token => {
    const SIGN_UP_ENDPOINT = `${baseUrl}/registration/user`
    const monthVal = DeviceId.isDesktop() ? values.month.value : values.month
    const formFields = {
      ...values,
      month: monthNumericMap[monthVal],
      ...arrFormReferers(),
      'g-recaptcha-response': token,
    }
    const formElement = document.createElement('form')
    formElement.setAttribute('name', 'frmRegistration')
    formElement.setAttribute('id', 'frmRegistration')
    formElement.setAttribute('method', 'post')
    formElement.setAttribute('action', SIGN_UP_ENDPOINT)
    Object.keys(formFields).forEach(key => {
      const eleName = key
      const eleVal =
        typeof formFields[key] === `object`
          ? formFields[key].value
          : formFields[key]
      formElement.appendChild(createFormElement(eleName, eleVal))
    })
    document.body.appendChild(formElement)
    document.getElementById('frmRegistration').submit()
  })
}

const createFormElement = (eleName, eleVal) => {
  const inputElement = document.createElement('input')
  inputElement.setAttribute('type', 'hidden')
  inputElement.setAttribute('name', eleName)
  inputElement.setAttribute('value', eleVal)
  return inputElement
}

const validateSetupAccount = values => {
  const errors = {}
  if (!values.postedby) {
    errors.postedby = 'Please specify whose profile is being created'
  }
  return errors
}

const Register = props => {
  const {
    data: {
      airtable: {
        fields: { domainReligion, domainLanguage, domainCountry },
      },
    },
  } = props

  return (
    <Wizard
      initialValues={{
        community: domainReligion !== 'Select' ? domainReligion : '',
        mother_tongue: domainLanguage !== 'Select' ? domainLanguage : '',
        countryofresidence: domainCountry,
      }}
      onSubmit={onSubmit}
    >
      <Wizard.Page validate={validateSetupAccount}>
        <SetupAccount />
      </Wizard.Page>
      <Wizard.Page>
        <BasicDetails
          domainReligion={domainReligion}
          domainLanguage={domainLanguage}
          domainCountry={domainCountry}
        />
      </Wizard.Page>
    </Wizard>
  )
}

export default Register
